<template>
  <div class="container bg-light my-3 py-3 px-4">

    <div class="row">
      <div class="col-12">
        <h2 class="ms-4 text-start">User Info</h2>
        <hr>
      </div>
    </div>

    <div class="row">
      <div class="mt-2 col-12 col-lg-4">
        <ca-smtt-card 
          name="User full name"
          :description="`${user.name} ${user.last_name}`"
        />
      </div>

      <div class="mt-2 col-12 col-lg-4">
        <ca-smtt-card 
          name="Username"
          :description="user.username"
        />
      </div>

      <div class="mt-2 col-12 col-lg-4">
        <ca-smtt-card 
          name="Email"
          :description="user.email"
        />
      </div>
    </div>

    <div class="mt-2 row">

      <div class="mt-2 col-12 col-lg-4">
        <ca-smtt-card 
          name="Status"
          :description="user.is_available ? 'Active': 'Inactive'"
        />
      </div>

    </div>

  </div>
</template>
<script>
import {getUserById} from '@/services/users/user.api.js'
import CaSmttCard from '../../components/ca-smtt-card.vue'

export default {
  data() {
    return {
      user: {}
    }
  },
  components: {CaSmttCard},
  async mounted() {
    await this.getUserData()
  },
  computed: {
    userId() {return this.$route.params.id}
  },
  methods: {
    async getUserData() {
      try {
        const { data } = await getUserById(this.userId)
        this.user = data.user
        console.log(this.user)
      } catch (error) {
        console.log(error)
      }
    }
  },
}
</script>
<style scoped>
  
</style>